import {onClick} from '../abstract/helpers.js';

export class HeaderSlider {
  constructor() {

    if(document.querySelector('.dropdown-navigation-detailed .about .stories-of-change .content .restrict-width .custom-slider')) {
      
      onClick(document.querySelector('#header-slider-down'), function (e) {
        e.preventDefault();
        document.querySelector('.dropdown-navigation-detailed .about .stories-of-change .content .restrict-width .custom-slider').appendChild(  document.querySelector('.dropdown-navigation-detailed .about .stories-of-change .stories-of-change-card-small:first-child') );
      }.bind(this));
      
      onClick(document.querySelector('#header-slider-up'), function (e) {
        e.preventDefault();
        document.querySelector('.dropdown-navigation-detailed .about .stories-of-change .content .restrict-width .custom-slider').prepend(  document.querySelector('.dropdown-navigation-detailed .about .stories-of-change .stories-of-change-card-small:last-child') );
      }.bind(this));
    }
  }

}


